<template>
  <div>
    <b-row v-if="isLoading">
      <b-col md="6">
        <atom-spinner
          :animation-duration="1000"
          :size="60"
          color="#ff1d5e"
          class="float-right my-4"
        />
      </b-col>
    </b-row>
    <div v-else>
      <component-header
        title="View Tenant"
        :hasSearch="false"
        :hasReload="false"
        :hasCreate="false"
        :hasback="true"
        @back-press="$router.push('/tenant')"
      />
      <b-row>
        <b-col md="3">
          <profileCard
            :imageUrl="currentTenant.company.logo"
            :name="currentTenant.company.name"
            :email="currentTenant.authentication.email"
            :phone="currentTenant.authentication.phone"
          >
            <div class="d-flex justify-content-center">
              <b-button
                size="sm"
                class="mr-2 my -0 main-navigation-button mx-3"
                variant="primary"
                v-b-modal.modal-1
                @click="kycByUser"
              >
                KYC Details
              </b-button>
            </div>
          </profileCard>
        </b-col>
        <b-col>
          <b-card style="border-radius: 16px; border: 1px solid #dee3ea">
            <h3 class="ml-1 mb-2">Tenant Information</h3>
            <b-row class="px-2 mt-1">
              <b-col>
                <b-row>
                  <b-col md="5">
                    <p class="left-text">Country :</p>
                  </b-col>
                  <b-col md="7">
                    <p class="right-text">
                      {{ currentTenant.address.country }}
                    </p>
                  </b-col>
                </b-row>
              </b-col>
              <b-col>
                <b-row>
                  <b-col style="border-left: 1px dashed #c2c2c2" md="5">
                    <p class="left-text">State :</p>
                  </b-col>
                  <b-col md="7">
                    <p class="right-text">
                      {{ currentTenant.address.state }}
                    </p>
                  </b-col>
                </b-row>
              </b-col>
            </b-row>
            <b-row
              style="border-bottom: 1px dashed #c2c2c2"
              class="m-2"
            ></b-row>
            <b-row class="px-2">
              <b-col>
                <b-row>
                  <b-col md="5">
                    <p class="left-text">City :</p>
                  </b-col>
                  <b-col md="7">
                    <p class="right-text">
                      {{ currentTenant.address.city }}
                    </p>
                  </b-col>
                </b-row>
              </b-col>
              <b-col>
                <b-row>
                  <b-col style="border-left: 1px dashed #c2c2c2" md="5">
                    <p class="left-text">Zipcode :</p>
                  </b-col>
                  <b-col md="7">
                    <p class="right-text">
                      {{ currentTenant.address.zip }}
                    </p>
                  </b-col>
                </b-row>
              </b-col>
            </b-row>
            <b-row
              style="border-bottom: 1px dashed #c2c2c2"
              class="m-2"
            ></b-row>
            <b-row class="px-2">
              <b-col>
                <b-row>
                  <b-col md="5">
                    <p class="left-text">Street 1 :</p>
                  </b-col>
                  <b-col md="7">
                    <p class="right-text">
                      {{ currentTenant.address.street1 }}
                    </p>
                  </b-col>
                </b-row>
              </b-col>
              <b-col>
                <b-row>
                  <b-col style="border-left: 1px dashed #c2c2c2" md="5">
                    <p class="left-text">Street 2 :</p>
                  </b-col>
                  <b-col md="7">
                    <p class="right-text">
                      {{ currentTenant.address.street2 }}
                    </p>
                  </b-col>
                </b-row>
              </b-col>
            </b-row>
          </b-card>
          <b-card style="border-radius: 16px; border: 1px solid #dee3ea">
            <h3 class="ml-1 mb-2">Tenant Access</h3>
            <b-row class="px-2">
              <b-col>
                <b-row>
                  <b-col md="5">
                    <p class="left-text">User Name :</p>
                  </b-col>
                  <b-col md="7">
                    <p class="right-text">
                      {{ currentTenant.authentication.userName }}
                    </p>
                  </b-col>
                </b-row>
              </b-col>
              <b-col>
                <b-row>
                  <b-col style="border-left: 1px dashed #c2c2c2" md="5">
                    <p class="left-text">Category :</p>
                  </b-col>
                  <b-col md="7">
                    <p class="right-text">
                      {{ currentTenant.category }}
                    </p>
                  </b-col>
                </b-row>
              </b-col>
            </b-row>
          </b-card>
        </b-col>
      </b-row>
      <b-modal
        id="modal-1"
        scrollable
        size="lg"
        title="KYC Details"
        centered
        ok-only
      >
        <b-row v-if="loading">
          <b-col md="12" class="text-center">
            <h4>Loading....</h4>
          </b-col>
        </b-row>
        <b-row class="px-5 py-2" v-else-if="kycUser && kycUser.documents">
          <div>
            <kycView :kycDocuments="kycUser.documents" />
          </div>
        </b-row>
        <b-row v-else>
          <b-col md="12" class="text-center">
            <h4>KYC Data Not Found</h4>
          </b-col>
        </b-row>
      </b-modal>
    </div>
  </div>
</template>
<script>
import cTelInput from "@/components/Common/MobileNumberInput";
import ComponentHeader from "@/components/componentNewHeader";
import ebSelect from "@/components/FormElements/Select";
import ebButton from "@/components/FormElements/Button";
import kycView from "@/components/Tenant/kycView.vue";
import { mapGetters } from "vuex";
import { AtomSpinner } from "epic-spinners";
import profileCard from "@/components/Generics/profileCard.vue";
export default {
  name: "Edituser",
  components: {
    ebButton,
    cTelInput,
    ComponentHeader,
    ebSelect,
    profileCard,
    AtomSpinner,
    kycView,
  },
  data() {
    return {
      loading: false,
      isLoading: false,
      currentTenant: {
        company: {
          logo: "",
          name: "",
        },
        address: {
          state: "",
          city: "",
          country: "",
          zip: "",
          street1: "",
          street2: "",
        },
        authentication: {
          userName: "",
          phone: "",
          email: "",
        },
      },
    };
  },
  computed: {
    ...mapGetters({
      kycUser: "tenant/GetKycByUser",
    }),
    currentUser() {
      return this.currentTenant;
    },
  },
  methods: {
    async viewTenantDetails() {
      this.isLoading = true;
      try {
        const res = await this.$store.dispatch(
          "tenant/getTenantDetailByID",
          this.$route.params.id
        );
        if (res && res.status === 1) {
          this.currentTenant = res.response;
        } else {
          console.error("Failed to fetch tenant details:", res);
        }
      } catch (error) {
        console.error("Error fetching tenant details:", error);
      } finally {
        this.isLoading = false;
      }
    },
    async kycByUser() {
      this.loading = true;
      await this.$store
        .dispatch("tenant/fetchKYCListByUser", {
          id: this?.$route?.params?.id || "",
        })
        .then((result) => {});
      this.loading = false;
    },
  },
  mounted: async function () {
    await this.viewTenantDetails(); // Fetch tenant details on mount
  },
};
</script>

<style scoped>
.card {
  border-width: inherit;
  border-radius: 2px;
  box-shadow: 0 0 35px 0 rgba(154, 161, 171, 0.15) !important;
}

[col-4="image"] {
  background-color: aliceblue !important;
}

[btn-back="primary"] {
  background-color: var(--primary) !important;
  margin: 0px;
  height: 41px;
  color: white;
}
</style>
<style>
.footer-bottons-class {
  text-align: center;
  background: var(--primary) !important;
  margin-left: 40%;
}

.span-text {
  font-size: 15px;
  font-weight: normal;
  line-height: 24px;
}

.h5-text {
  font-size: 15px;
  line-height: 17px;
}
</style>
